<template>
  <b-modal
    :active.sync="isModalActive"
    has-modal-card
    class="is-large is-wider-modal"
  >
    <div
      class="modal-card enable-select-text"
      v-bind:class="[selectDisable ? '' : 'disabled']"
      style="width: 980px;"
    >
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">{{ action }} Data</h1>
        <b-checkbox v-model="showDropdownColumns" class="header-checkbox">
          <strong>Show Dropdown Columns</strong>
        </b-checkbox>
      </header>
      <section class="modal-card-body">
        <div class="columns no-padding-top header-row">
          <div class="column" v-if="importType == 'Products'">
            <b-checkbox
              v-model="form.isPrimary"
              name="actionCheckBox"
              value="false"
              class="header-checkbox"
            >
              <strong>Primary</strong>
            </b-checkbox>
          </div>
          <div class="column" v-else>
            <b-checkbox
              v-model="form.isPrimary"
              name="actionCheckBox"
              value="false"
              class="header-checkbox"
            >
              <strong>Primary</strong>
            </b-checkbox>
          </div>
          <div class="column">
            <strong>Content Preview</strong>
          </div>
          <div class="column" v-if="importType == 'Products'">
            <strong>Common Field</strong>
          </div>
          <div class="column" v-if="importType == 'Products'">
            <strong>Sheet Name</strong>
          </div>
          <div class="column"><strong>CDF column</strong></div>
          <div class="column" v-if="showDropdownColumns">
            <strong>Dropdown</strong>
          </div>
          <div class="column" v-if="showDropdownColumns">
            <strong>Dropdown Value</strong>
          </div>
        </div>
        <div
          v-for="column in suppressColumn
            ? columns.filter(col => col.mapping)
            : columns"
          :key="column.field"
          class="no-margin-bottom map-columns-row"
        >
          <div
            :name="column.field"
            :label="column.label"
            v-if="
              column.field != 'actions' &&
                column.field != 'Updated Date' &&
                column.field != 'Updated By'
            "
            class="columns column no-padding-top"
          >
            <div class="column description-column">
              <div class="description-text" :title="plainLabel(column.label)">
                <span v-html="column.label || ''"></span>
              </div>
            </div>
            <div class="column description-column">
              <div
                class="description-text"
                :title="
                  tableData && tableData[0]
                    ? tableData[0][column.field] || ''
                    : ''
                "
              >
                <span>{{
                  tableData && tableData[0] ? tableData[0][column.field] : ""
                }}</span>
              </div>
            </div>
            <div
              class="column checkbox-column mt-3"
              v-if="importType == 'Products'"
            >
              <b-checkbox
                name="actionCheckBox"
                :value="
                  form[column.field] ? form[column.field].common_field : 'false'
                "
                @input="insertFormVal(column.field, $event, 'common_field')"
              >
                is Common
              </b-checkbox>
            </div>
            <b-select
              v-if="importType == 'Products'"
              class="cdf-edit-add-padding cdf-edit-select column"
              @input="insertFormVal(column.field, $event, 'sheet_name')"
              :value="form[column.field] ? form[column.field].sheet_name : ''"
            >
              <option :value="null"></option>
              <option
                v-for="(value, index) in sheetsDropDown"
                :key="index"
                :title="value"
              >
                {{ value }}
              </option>
            </b-select>
            <b-select
              v-if="importType == 'Products'"
              class="cdf-edit-add-padding cdf-edit-select column"
              @input="insertFormVal(column.field, $event, 'name')"
              :value="form[column.field] ? form[column.field].name : ''"
            >
              <option :value="null"></option>
              <option
                v-for="(value, index) in getAvailableCdfOptions(column.field)"
                :key="index"
                :title="value.product_data_column"
              >
                {{ value.field_name }}
              </option>
            </b-select>
            <b-select
              v-else
              class="cdf-edit-add-padding cdf-edit-select column"
              :value="form[column.field] ? form[column.field].name : ''"
              @input="insertFormVal(column.field, $event, 'name')"
            >
              <option :value="null"></option>
              <option
                v-for="(value, index) in getAvailableCdfOptions(column.field)"
                :key="index"
                :title="value.product_data_column"
              >
                {{ value.field_name }}
              </option>
            </b-select>
            <b-select
              v-if="importType == 'Products' && showDropdownColumns"
              class="cdf-edit-add-padding cdf-edit-select column"
              @input="insertFormVal(column.field, $event, 'property')"
              :value="form[column.field] ? form[column.field].property : ''"
            >
              <option :value="null"></option>
              <option
                v-for="(value, index) in (
                  configDropDown[column.field] || []
                ).filter(v => v.field_type == 'Dropdown' && v.field_required)"
                :key="index"
                :title="value.product_data_column"
              >
                {{ value.field_name }}
              </option>
            </b-select>
            <b-select
              v-if="importType == 'Transactions' && showDropdownColumns"
              class="cdf-edit-add-padding cdf-edit-select column"
              @input="insertFormVal(column.field, $event, 'property')"
              :value="form[column.field] ? form[column.field].property : ''"
            >
              <option :value="null"></option>
              <option
                v-for="(value,
                index) in columnsConfig[0].template_fields.filter(
                  v =>
                    v.id !== 'weight_in_kg' &&
                    v.field_type == 'Dropdown' &&
                    v.field_required
                )"
                :key="index"
                :title="value.product_data_column"
              >
                {{ value.field_name }}
              </option>
            </b-select>
            <b-field
              v-if="showDropdownColumns"
              class="cdf-edit-add-padding cdf-edit-select column"
            >
              <b-select
                @input="insertFormVal(column.field, $event, 'property_value')"
                :value="
                  form[column.field] ? form[column.field].property_value : ''
                "
                searchable
              >
                <option :value="null"></option>
                <option
                  v-for="(value, index) in dropDownValues[column.field]"
                  :key="index"
                >
                  {{ value }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot" v-if="!disable">
        <b-button slot="right" type="is-primary" @click="saveData">
          Save
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Cancel
        </b-button>
      </footer>
      <footer class="modal-card-foot" v-if="disable">
        <b-button
          v-if="disable && this.action !== 'View'"
          slot="right"
          type="is-danger"
          @click="removeReport"
        >
          Delete
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import RulesManagerService from "../../services/RulesManagerService";
// @group Customers
export default {
  name: "SingleProductEdit",
  props: {
    action: {
      type: String,
      default: ""
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    documentSelected: {
      type: Object
    },

    customerId: {
      type: Number,
      default: -1
    },

    columns: {
      type: Array
    },

    tableData: {
      type: Array
    },

    importType: {
      type: String
    },

    allProductFamily: {
      type: Object
    },

    allMaterialDetail: {
      type: Object
    },
    columnsConfig: {
      type: Array
    },
    suppressColumnView: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      customerDataService: new CustomerProfileDataService(),
      isModalActive: false,
      selectDisable: true,
      form: {},
      editData: [],
      configDropDown: {},
      properties: [],
      propertyConfig: null,
      hasDropdown: {},
      hasNumericInput: {},
      dropDownValues: {},
      isPrimary: false,
      RulesManagerService: new RulesManagerService(),
      duplicateMappings: {}, // Track fields with duplicate mappings
      sheetsDropDown: [
        "PRODUCT SHEET",
        "WEEE",
        "BATT",
        "PACK",
        "COPY",
        "BUNDLE INFORMATION"
      ],
      showDropdownColumns: true,
      suppressColumn: false
    };
  },
  mounted() {
    this.disableSelectProperty();
  },
  computed: {
    disable() {
      if (this.action == "Edit") {
        return false;
      } else if (this.action == "View") {
        return true;
      } else if (this.action == "Delete") {
        return true;
      }
      return false;
    }
  },
  methods: {
    getDefaultMapping() {
      return {
        name: null,
        id: null,
        column_name: null,
        sheet_name: null,
        property: null,
        property_id: null,
        property_column_name: null,
        property_value: null,
        common_field: false
      };
    },
    insertFormVal(field, value, property) {
      // If the form field was previously null but we're setting a non-null value,
      // we need to initialize it as an empty object
      if (this.form[field] === null && value !== null) {
        this.$set(this.form, field, this.getDefaultMapping());
      }

      // Initialize the form field object if it doesn't exist yet
      if (!this.form[field]) {
        this.$set(this.form, field, this.getDefaultMapping());
      }

      // When selecting a CDF field (name property), check if it's already mapped
      // for the current sheet and not a quantity field for transactions
      if (property === "name" && value) {
        const currentSheetName = this.form[field].sheet_name || "default";
        const isQuantity =
          this.importType !== "Products" &&
          this.isQuantityField(value.field_name || value);

        // Skip validation for quantity fields in transactions, but not in products
        if (!isQuantity) {
          // Check if any other field already maps to this CDF field for the same sheet
          const duplicateField = Object.keys(this.form).find(otherField => {
            // Skip the current field and non-object mappings
            if (
              otherField === field ||
              otherField === "isPrimary" ||
              this.form[otherField] === null ||
              typeof this.form[otherField] !== "object"
            ) {
              return false;
            }

            const otherMapping = this.form[otherField];
            const otherSheetName = otherMapping.sheet_name || "default";

            // Check if mapping is for same sheet and same CDF field
            return (
              otherSheetName === currentSheetName &&
              ((value.id && otherMapping.id === value.id) ||
                (typeof value === "string" && otherMapping.name === value))
            );
          });

          if (duplicateField) {
            // Value is already mapped, clear this field
            return;
          }
        }
      }

      // Set the value on the form field
      this.$set(this.form[field], property, value);

      // If sheet_name or name (CDF column) is set to null, set the entire mapping to null
      if ((property === "sheet_name" || property === "name") && !value) {
        // Set the entire mapping to null
        this.$set(this.form, field, null);

        // Clear any duplicate tracking for this field
        this.$set(this.duplicateMappings, field, false);

        // Reset UI state
        this.$set(this.configDropDown, field, []);
        this.$set(this.hasDropdown, field, false);
        this.$set(this.hasNumericInput, field, false);
        this.$set(this.dropDownValues, field, []);

        return;
      }

      if (property == "sheet_name") {
        // When sheet_name is set but the rest of the code should run for other operations
        if (!value) {
          return; // We've already handled the null case above
        }

        // When sheet name changes, check for duplicates with the CDF field in the current field
        if (
          this.form[field].name &&
          typeof this.form[field].name !== "string"
        ) {
          const currentCdfField = this.form[field].name;
          const isQuantity =
            this.importType !== "Products" &&
            this.isQuantityField(currentCdfField.field_name || currentCdfField);

          // Skip validation for quantity fields in transactions, but not in products
          if (!isQuantity) {
            // Check if any other field already maps to this CDF field for the same sheet
            const duplicateField = Object.keys(this.form).find(otherField => {
              // Skip the current field and non-object mappings
              if (
                otherField === field ||
                otherField === "isPrimary" ||
                this.form[otherField] === null ||
                typeof this.form[otherField] !== "object"
              ) {
                return false;
              }

              const otherMapping = this.form[otherField];
              const otherSheetName = otherMapping.sheet_name || "default";

              // Check if mapping is for same sheet and same CDF field
              // Check if sheet names match and if CDF fields match
              const sheetsMatch = otherSheetName === value;
              const idMatch =
                currentCdfField.id && otherMapping.id === currentCdfField.id;
              const nameMatch =
                typeof currentCdfField === "string" &&
                otherMapping.name === currentCdfField;
              const cdfMatch = idMatch || nameMatch;

              return sheetsMatch && cdfMatch;
            });

            if (duplicateField) {
              // Value is already mapped, prevent selection
              return;
            }
          }
        }

        if (
          !this.columnsConfig ||
          !this.columnsConfig[0] ||
          !this.columnsConfig[0].template_fields
        ) {
          this.$set(this.configDropDown, field, []);

          // Reset property-related fields when sheet_name changes
          this.form[field].property = null;
          this.form[field].property_id = null;
          this.form[field].property_column_name = null;
          this.form[field].property_value = null;

          // Also reset the property UI state
          this.$set(this.hasDropdown, field, false);
          this.$set(this.hasNumericInput, field, false);
          this.$set(this.dropDownValues, field, []);

          return;
        }

        // Filter template fields by sheet name
        const filteredFields = this.columnsConfig[0].template_fields.filter(
          config => config.sheet_name === value
        );

        this.$set(this.configDropDown, field, filteredFields || []);

        // Reset property-related fields when sheet_name changes
        this.form[field].property = null;
        this.form[field].property_id = null;
        this.form[field].property_column_name = null;
        this.form[field].property_value = null;

        // Also reset the property UI state
        this.$set(this.hasDropdown, field, false);
        this.$set(this.hasNumericInput, field, false);
        this.$set(this.dropDownValues, field, []);

        // Find dropdown fields for the new sheet
        this.properties = filteredFields.find(
          field => field.field_type === "Dropdown"
        );
      }

      // Rest of the method remains the same...
      if (property == "property") {
        this.setValueForProperty(field, value);
      }

      if (property == "name") {
        this.setValueForName(field, value);

        // Also reset the property when the name changes
        this.form[field].property = null;
        this.form[field].property_id = null;
        this.form[field].property_column_name = null;
        this.form[field].property_value = null;

        // Reset the property UI state
        this.$set(this.hasDropdown, field, false);
        this.$set(this.hasNumericInput, field, false);
        this.$set(this.dropDownValues, field, []);
      }
    },
    // Fixed setValueForName method for both Products and Transactions
    setValueForName(field, value) {
      // Early exit if value is null or undefined
      if (!value) {
        // Since we've modified insertFormVal to set the entire form[field] to null,
        // we don't need to do anything else here
        return;
      }

      // Determine the field name regardless of value type
      const fieldName = typeof value === "string" ? value : value.field_name;

      // If field name is empty, exit early
      if (!fieldName) {
        return;
      }

      // Handle Products
      if (this.importType == "Products") {
        // Make sure configDropDown exists for this field
        if (!this.configDropDown[field]) {
          return;
        }

        // Find the property in the configDropDown for this field
        const selectedProperty = this.configDropDown[field].find(
          prop => prop.field_name === fieldName
        );

        if (selectedProperty) {
          // Set the ID and column_name
          this.$set(this.form[field], "id", selectedProperty.id || null);

          // Use product_data_column for Products, with fallback to transaction_data_column
          this.$set(
            this.form[field],
            "column_name",
            selectedProperty.product_data_column ||
              selectedProperty.column_name ||
              selectedProperty.transaction_data_column ||
              null
          );
        } else {
          console.warn(
            `No matching property found for field: ${field}, value: ${fieldName}`
          );
        }
      }
      // Handle Transactions
      else if (this.importType == "Transactions") {
        const selectedProperty = this.columnsConfig[0].template_fields.find(
          prop => prop.field_name === fieldName
        );

        if (selectedProperty) {
          this.$set(
            this.form[field],
            "id",
            selectedProperty.template_field || null
          );
          this.$set(
            this.form[field],
            "column_name",
            selectedProperty.transaction_data_column || null
          );
        }
      }
    },
    setValueForProperty(field, value) {
      const selectedProperty = this.columnsConfig[0].template_fields.find(
        prop => prop.field_name === value
      );
      if (!selectedProperty) {
        // Prevent error if not found
        this.$set(this.hasDropdown, field, false);
        this.$set(this.hasNumericInput, field, false);
        this.$set(this.dropDownValues, field, []);
        return;
      }
      this.$set(this.form[field], "property_id", selectedProperty.id || null);

      // Handle different column name fields based on import type
      if (this.importType == "Products") {
        this.$set(
          this.form[field],
          "property_column_name",
          selectedProperty.product_data_column ||
            selectedProperty.column_name ||
            selectedProperty.transaction_data_column ||
            null
        );
      } else {
        this.$set(
          this.form[field],
          "property_column_name",
          selectedProperty.transaction_data_column || null
        );
      }
      const property = selectedProperty;
      if (property?.field_type == "Dropdown") {
        this.$set(this.hasDropdown, field, true);
        let values = property.dropdown_field_values;
        if (
          property.product_data_column == "material_detail" ||
          property.product_data_column == "product_family"
        ) {
          values = [];
          for (const key of Object.values(property.dropdown_field_values[0])) {
            const filteredKey = key.filter(item => item !== "NA");
            values = values.concat(filteredKey);
          }
          // Add "NA" back once after all concatenation is done
          values.push("NA");
        }
        this.$set(this.dropDownValues, field, values);
        this.$set(this.hasNumericInput, field, false);
      } else {
        this.$set(this.hasDropdown, field, false);
        if (property?.field_type == "Number") {
          this.$set(this.hasNumericInput, field, true);
        } else {
          this.$set(this.hasNumericInput, field, false);
        }
        this.$set(this.dropDownValues, field, []);
      }
    },
    disableSelectProperty() {
      if (this.isAction == "Edit" || this.action == "Delete") {
        this.selectDisable = false;
      }
    },
    cancel() {
      this.$emit("cancel");
    },

    // Helper method to check if a field is a quantity field
    isQuantityField(fieldName) {
      // Check if the field name contains "quantity" (case-insensitive)
      return fieldName && fieldName.toLowerCase().includes("quantity");
    },

    // Method to validate that no duplicate CDF mappings exist for the same sheet
    validateNoDuplicateMappings() {
      // Create a map to track which CDF fields are used for each sheet
      const mappedFields = {};

      // Track duplicate mappings for error reporting
      const duplicates = [];

      // For each field in the form
      Object.keys(this.form).forEach(field => {
        // Skip isPrimary field and null fields
        if (field === "isPrimary" || this.form[field] === null) return;

        const mapping = this.form[field];

        // Only check objects with name and id (valid mappings)
        if (typeof mapping === "object" && mapping.name && mapping.id) {
          const sheetName = mapping.sheet_name || "default";
          const cdfField = mapping.name;
          const cdfId = mapping.id;

          // Create entry for this sheet if it doesn't exist
          if (!mappedFields[sheetName]) {
            mappedFields[sheetName] = {};
          }

          // Check if this is a quantity field in transactions (we allow multiple quantity mappings only for transactions)
          const isQuantity =
            this.importType !== "Products" && this.isQuantityField(cdfField);

          // Check if this CDF field is already mapped for this sheet
          if (mappedFields[sheetName][cdfId] && !isQuantity) {
            duplicates.push({
              sheet: sheetName,
              field: cdfField,
              columns: [mappedFields[sheetName][cdfId], field]
            });
          } else {
            // Record this mapping
            mappedFields[sheetName][cdfId] = field;
          }
        }
      });

      // If duplicates exist, return error information
      if (duplicates.length > 0) {
        return {
          valid: false,
          duplicates
        };
      }

      // No duplicates found
      return { valid: true };
    },
    getAvailableCdfOptions(field) {
      const getOptionKey = option => option?.id || option?.template_field;

      const getMappedKey = mapping => mapping?.id || mapping?.template_field;

      const getMappedFieldName = mapping => {
        if (!mapping) return null;
        if (typeof mapping.name === "string") return mapping.name;
        return mapping?.name?.field_name || null;
      };

      if (this.importType === "Products") {
        const baseOptions = (this.configDropDown[field] || []).filter(
          v => v.field_required
        );
        const sheetName = this.form[field]?.sheet_name;

        const mappedKeys = new Set();
        const mappedFieldNames = new Set();
        Object.keys(this.form).forEach(f => {
          if (
            f !== field &&
            f !== "isPrimary" &&
            this.form[f] &&
            this.form[f].sheet_name === sheetName
          ) {
            const mappedKey = getMappedKey(this.form[f]);
            const mappedFieldName = getMappedFieldName(this.form[f]);
            if (mappedKey) {
              mappedKeys.add(mappedKey);
            }
            if (mappedFieldName) {
              mappedFieldNames.add(mappedFieldName);
            }
          }
        });

        return baseOptions.filter(opt => {
          const optionKey = getOptionKey(opt);
          const isMappedByKey = optionKey && mappedKeys.has(optionKey);
          const isMappedByName =
            opt?.field_name && mappedFieldNames.has(opt.field_name);
          return !isMappedByKey && !isMappedByName;
        });
      }

      const baseOptions = (this.columnsConfig[0]?.template_fields || []).filter(
        v => v.id !== "weight_in_kg" && v.field_required
      );

      const mappedKeys = new Set();
      const mappedFieldNames = new Set();
      Object.keys(this.form).forEach(f => {
        if (
          f !== field &&
          f !== "isPrimary" &&
          this.form[f] &&
          (this.form[f].id || this.form[f].template_field || this.form[f].name)
        ) {
          const mappedKey = getMappedKey(this.form[f]);
          const mappedFieldName = getMappedFieldName(this.form[f]);
          if (mappedKey) {
            mappedKeys.add(mappedKey);
          }
          if (mappedFieldName) {
            mappedFieldNames.add(mappedFieldName);
          }
        }
      });

      return baseOptions.filter(opt => {
        const optionKey = getOptionKey(opt);
        const isMappedByKey = optionKey && mappedKeys.has(optionKey);
        const isMappedByName =
          opt?.field_name && mappedFieldNames.has(opt.field_name);
        return !isMappedByKey && !isMappedByName;
      });
    },

    saveData() {
      delete this.form.actions;
      // Set this explicitly to ensure it's included even if the checkbox wasn't touched
      if (this.documentSelected) {
        this.documentSelected.is_primary = this.form.isPrimary;
      }

      // Check if we have any tracked duplicate mappings
      const hasDuplicates = Object.values(this.duplicateMappings).some(
        isDuplicate => isDuplicate === true
      );

      if (hasDuplicates) {
        // There are known duplicate mappings
        this.$buefy.dialog.alert({
          title: "Cannot Save with Duplicate Mappings",
          message:
            this.importType === "Products"
              ? "You have duplicate CDF field mappings in the same product sheet. Please fix these issues before saving."
              : "You have duplicate CDF field mappings in the same transaction sheet. Please fix these issues before saving.",
          confirmText: "Close",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return;
      }

      // Validate that no duplicate mappings exist
      const validationResult = this.validateNoDuplicateMappings();

      if (!validationResult.valid) {
        // Construct error message about duplicate mappings with import type context
        let errorHeader = "";

        if (this.importType === "Products") {
          errorHeader =
            "CDF field cannot be mapped to multiple columns in the same product sheet.\n\n";
        } else {
          errorHeader =
            "CDF field cannot be mapped to multiple columns in the same transaction sheet.\n\n";
        }

        let errorMsg = errorHeader;

        validationResult.duplicates.forEach(dup => {
          errorMsg += `${
            this.importType === "Products"
              ? "In sheet " + dup.sheet + ", the"
              : "The"
          } CDF field "${
            dup.field
          }" is mapped to multiple columns: ${dup.columns.join(", ")}\n`;
        });

        // Display the error message
        this.$buefy.dialog.alert({
          title: "Duplicate Mapping Error",
          message: errorMsg,
          confirmText: "Close",
          ariaRole: "alertdialog",
          ariaModal: true
        });

        return; // Prevent saving
      }

      // Clean up form data before saving
      const cleanedForm = { ...this.form };

      // For each field in the form
      Object.keys(cleanedForm).forEach(field => {
        // Skip isPrimary field
        if (field === "isPrimary") return;

        // If the field is null, continue (we want to keep it as null)
        if (cleanedForm[field] === null) return;

        // Handle objects
        if (typeof cleanedForm[field] === "object") {
          // If sheet_name or name is null for Products, set the entire mapping to null
          if (
            this.importType === "Products" &&
            (!cleanedForm[field].sheet_name || !cleanedForm[field].name)
          ) {
            cleanedForm[field] = null;
          }
          // For Transactions, if name is null, set the entire mapping to null
          else if (
            this.importType === "Transactions" &&
            !cleanedForm[field].name
          ) {
            cleanedForm[field] = null;
          }
        }
      });

      this.$emit("updateMapColumns", cleanedForm);
    },
    plainLabel(html) {
      if (!html) return "";
      // Use a regex to strip HTML tags
      return html.replace(/<[^>]*>?/gm, "");
    }
  },

  watch: {
    suppressColumnView(newValue) {
      this.suppressColumn = newValue;
    },
    isActive(newValue) {
      this.isModalActive = newValue;
      if (newValue) {
        // Initialize form and configDropDown for all columns
        this.form = {
          isPrimary: this.documentSelected
            ? this.documentSelected.is_primary
            : false
        };

        // Reset duplicate mappings tracking
        this.duplicateMappings = {};

        // Initialize configDropDown for all columns to avoid undefined errors
        this.columns.forEach(column => {
          if (
            column.field != "actions" &&
            column.field != "Updated By" &&
            column.field != "Updated Date"
          ) {
            this.$set(this.configDropDown, column.field, []);
          }
        });
        this.columns.forEach(column => {
          if (
            column.field != "actions" &&
            column.field != "Updated By" &&
            column.field != "Updated Date"
          ) {
            // Always initialize all keys for all columns
            const mapping =
              column.mapping && typeof column.mapping === "object"
                ? column.mapping
                : {};

            // Check if mapping should be set to null based on our rules
            const shouldBeNull =
              (this.importType === "Products" &&
                (!mapping.sheet_name || !mapping.name)) ||
              (this.importType === "Transactions" && !mapping.name);

            if (shouldBeNull) {
              // Set the entire mapping to null
              this.$set(this.form, column.field, null);
            } else {
              // Make sure the form field exists as an object
              this.$set(this.form, column.field, {
                name:
                  mapping.name ||
                  (typeof column.mapping === "string" ? column.mapping : null),
                id: mapping.id || null,
                column_name: mapping.column_name || null,
                sheet_name: mapping.sheet_name || null,
                property: mapping.property || null,
                property_id: mapping.property_id || null,
                property_column_name: mapping.property_column_name || null,
                property_value: mapping.property_value || null,
                common_field: mapping.common_field || false
              });
            }

            // If the form field exists and name exists but column_name is missing, try to set it
            if (
              this.form[column.field] &&
              this.form[column.field].name &&
              !this.form[column.field].column_name
            ) {
              this.setValueForName(column.field, this.form[column.field].name);
            }

            // For Products, set configDropDown and property logic
            if (this.importType == "Products" && mapping.sheet_name) {
              const filteredFields = this.columnsConfig[0].template_fields.filter(
                config =>
                  config.sheet_name === mapping.sheet_name &&
                  config.field_required === true
              );

              // Make sure we're setting a valid array
              this.$set(
                this.configDropDown,
                column.field,
                filteredFields || []
              );
            }
            if (mapping.property) {
              // Set property-related values
              this.setValueForProperty(column.field, mapping.property);
            } else {
              // Set default property values
              this.$set(this.hasDropdown, column.field, false);
              this.$set(this.hasNumericInput, column.field, false);
            }
          }
        });
      }
      if (!newValue) {
        this.cancel();
      }
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>

<style scoped>
.description-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limit to 2 lines */
  line-clamp: 2; /* Standard property for compatibility */
  -webkit-box-orient: vertical;
  line-height: 1.2;
  font-weight: bold;
}

.header-row .column {
  display: flex;
  align-items: center;
}

.header-checkbox {
  margin-top: 0;
}

.checkbox-column {
  display: flex;
  align-items: center;
  height: 42px;
}

.description-column {
  margin-top: 12px;
}

.scrollable-modal-body {
  max-height: 60vh;
  overflow: auto;
}
</style>
